import firebase from 'firebase';

const firebaseConfig = {
    apiKey: "AIzaSyA1zsawpqd8UiLSe1hFVi3fRfaJBBFVIjQ",
    authDomain: "tinder-clone-7eff5.firebaseapp.com",
    projectId: "tinder-clone-7eff5",
    storageBucket: "tinder-clone-7eff5.appspot.com",
    messagingSenderId: "158879356278",
    appId: "1:158879356278:web:38938afc1725a2cfa11657",
    measurementId: "G-J75VSB151C"
};

const firebaseApp = firebase.initializeApp(firebaseConfig);
const database = firebaseApp.firestore();

export default database;